import { MySvgIcon, MySvgIconProps } from './MySvgIcon'

type IconQuestionCircleProps = MySvgIconProps & {
  className?: string
  focusable?: boolean
  title?: string
}

export const IconQuestionCircle = ({ ...props }: IconQuestionCircleProps) => (
  <MySvgIcon
    width="21px"
    height="21px"
    viewBox="0 0 512 512"
    version="1.1"
    title="Question mark with circle"
    ariaHidden
    {...props}
  >
    <g fill="currentColor" fillRule="nonzero">
      <path d="M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zM169.8 165.3c7.9-22.3 29.1-37.3 52.8-37.3h58.3c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24V250.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1H222.6c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM288 352c0 17.7-14.3 32-32 32s-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32z" />
    </g>
  </MySvgIcon>
)
